import React from "react";
import "./loading.css"

const Loading = () => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      width: "100%",
    }}>
      <div style={{
        border: "3px solid #f3f3f3",
        borderRadius: "50%",
        borderTop: "3px solid #3a3f6a",
        width: "40px",
        height: "40px",
        animation: "spin 1s linear infinite",
        marginBottom: "0.2rem",
      }}></div>
      <p className="loading-text" style={{fontFamily: "Filson Pro"}}>Loading...</p>
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loading;